/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 3V13M12 3H7M12 3H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 19L2 19M22 19L19.5 16.5M22 19L19.5 21.5M2 19L4.5 16.5M2 19L4.5 21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M12 3V13M12 3H7M12 3H17M22 19L2 19M22 19L19.5 16.5M22 19L19.5 21.5M2 19L4.5 16.5M2 19L4.5 21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12 3V13M12 3H7M12 3H17M22 19L2 19M22 19L19.5 16.5M22 19L19.5 21.5M2 19L4.5 16.5M2 19L4.5 21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M7 3H17M12 6V13M2 19L4.5 16.5M2 19L4.5 21.5M2 19H10M22 19L19.5 16.5M22 19L19.5 21.5M22 19L14 19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 3V13M12 3H7M12 3H17M22 19L2 19M22 19L19.5 16.5M22 19L19.5 21.5M2 19L4.5 16.5M2 19L4.5 21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M12 3V13M12 3H7M12 3H17M22 19L2 19M22 19L19.5 16.5M22 19L19.5 21.5M2 19L4.5 16.5M2 19L4.5 21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
